export default __webpack_public_path__ + "static/media/video-overlay.c3a41e01.svg";